<template>
  <div>
    <div ref="qrCode" class="qr-code text-center"></div>
  </div>
</template>

<script>
  import QRCodeStyling from 'qr-code-styling'
  // import projectLogo from "@/assets/logo/Logo-VietQR.png";
  import projectLogo from '@/assets/logo/VietQR.svg'

  export default {
    name: 'QRCodeStyling',
    props: {
      data: {
        type: String,
        required: true, // Ensure that data for the QR code is always provided
      },
      logo: {
        type: String,
        default: projectLogo, // Optional: provide a default or leave it as null if no logo
      },
      size: {
        type: Number,
        default: 300, // Allow dynamic resizing of the QR code
      },
      dotColor: {
        type: String,
        default: 'black', // Allow customization of the dot color, default to blue
      },
      dotType: {
        type: String,
        default: 'rounded', // Allow customization of dot shape, default to rounded
      },
      cornerSquareType: {
        type: String,
        default: 'extra-rounded', // Allow customization of corner square shape
      },
      cornerDotType: {
        type: String,
        default: 'extra-rounded', // Allow customization of corner dot shape
      },
      backgroundOptions: {
        type: Object,
        default: () => ({
          color: '#ffffff', // White background color
        }),
      },
      imageOptions: {
        type: Object,
        default: () => ({
          crossOrigin: 'anonymous', // Ensure image is loaded correctly
          margin: 5, // Space around the logo
          imageSize: 0.5, // Adjust the size of the logo
          hideBackgroundDots: true, // Ẩn các chấm QR phía sau hình ảnh
        }),
      },
      qrOptions: {
        type: Object,
        default: () => ({
          typeNumber: 0,
          mode: 'Byte',
          errorCorrectionLevel: 'H',
        }),
      },
    },
    mounted() {
      const qrCode = new QRCodeStyling({
        width: this.size,
        height: this.size,
        // type: "svg",
        data: this.data, // Use passed-in data
        image: this.logo, // Use passed-in logo image
        dotsOptions: {
          color: this.dotColor, // Use passed-in or default color
          type: this.dotType, // Use passed-in or default dot type
        },
        backgroundOptions: this.backgroundOptions,
        imageOptions: this.imageOptions,
        cornersSquareOptions: {
          type: this.cornerSquareType, // Use passed-in or default corner square type
        },
        cornersDotOptions: {
          type: this.cornerDotType, // Use passed-in or default corner dot type
        },
        qrOptions: this.qrOptions,
        margin: 0,
      })

      // Render QR code to the element
      qrCode.append(this.$refs.qrCode)
    },
  }
</script>

<style scoped></style>
